import { defaultSwiperOptions } from '../../General/SwiperInit';
import Swiper, {
    Navigation,
    Pagination,
    Mousewheel,
    A11y,
    EffectFade,
    Keyboard,
    Autoplay,
    Lazy,
    Scrollbar,
} from 'swiper';

Swiper.use([Navigation, Pagination, Mousewheel, A11y, EffectFade, Keyboard, Autoplay, Lazy, Scrollbar]);

function initTeaserSlider() {
    [...document.querySelectorAll('.image-slider-container')].forEach((container) => {
        const sliderEl = container.querySelector('.image-slider');
        if (!sliderEl) {
            return;
        }

        const swiper = new Swiper(sliderEl, {
            ...defaultSwiperOptions,
            slidesPerView: 1,
            spaceBetween: 30,

            breakpoints: {
                1025: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            },
            slideClass: 'image-slide-item',
            navigation: {
                nextEl: container.querySelector('.swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: container.querySelector('.swiper-pagination'),
                dynamicBullets: true,
                clickable: true,
            },
        });
    });
}

initTeaserSlider();

document.addEventListener(
    'Neos.NodeCreated',
    function (event) {
        if (
            (event.detail.element && event.detail.element.classList.contains('image-slider-container')) ||
            event.detail.element.classList.contains('image-slide-item')
        ) {
            initTeaserSlider();
        }
    },
    false
);
